import { useIsPC } from '~/lib/ua'
import { css, sva } from '~/styled-system/css'
import { Section } from '../Section'
import { CancelPolicy } from '../cancelPolicy'
import { Notes } from '../notes'
export function Agreement() {
  const isPC = useIsPC()
  const Agreement_ = isPC ? PcAgreement : SdAgreement
  return <Agreement_ />
}

const pcStyle = sva({
  slots: ['container', 'title', 'content'],
  base: {
    container: {
      bg: 'white',
      p: '6',
      spaceY: '3',
    },
    title: {
      fontSize: '2xl',
      fontWeight: 'bold',
    },
    content: {
      rounded: 'default',
      divideY: 'thin',
      divideColor: 'gray.200',
      dsY: '1',
    },
  },
})

function PcAgreement() {
  const classes = pcStyle()
  return (
    <div className={classes.container}>
      <h2 className={classes.title}>予約時の同意事項</h2>
      <div className={classes.content}>
        <CancelPolicy />
        <Notes />
      </div>
    </div>
  )
}

function SdAgreement() {
  return (
    <Section title="予約時の同意事項" sectionClass={css({ pb: '2', spaceY: '1' })}>
      <CancelPolicy />
      <Notes />
    </Section>
  )
}
